module.exports = __webpack_public_path__ + "static/media/calenderDate.a8b3357d.svg";